module.exports = __webpack_public_path__ + "img/banner-09备份.5a23d501.png";